export default __webpack_public_path__ + "static/media/trunck.5dbefaa5.svg";